import { Scope } from 'types/company/access';

export const hasScope = (scope: Scope, scopes: Scope[]) =>
  scopes.filter(s => s.action === scope.action && s.resource === scope.resource && s.actingAs === scope.actingAs)
    .length > 0;
